define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/_base/underscore",
	"csi/comm",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/dgrid/MatrixEditorWithCheckBox",
	"csi/form/Widget",
	"csi/resolver",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/state",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/model/productSource",
	"Apparel/ProductType",
	"./SupplierQuoteRightWidget",
	"Sourcing",
], function (array, declare, lang, Memory, csi, _, comm, def, Action, Field, Relationship, ViewRef, MatrixEditorWithCheckBox, Widget, resolver, html, locale,
	reflection, state, csiStore, Names, xml, Query, { ATTR_SOURCE_SUPPLIER_ITEMS, ATTR_SOURCING_SOURCES, TYPE_PRODUCT_SOURCE }, ProductType, SupplierQuoteRightWidget, Sourcing) {

	var NONE = 0,
		COLORS = 1,
		SIZES = 2,
		COLORS_AND_SIZES = 3,
		QUOTE_PER_ACTIVE_COLOR = 4; // Quote per active color

	const PRODUCT_SOURCES = "ProductSources";
	const PRODUCT_ALTERNATIVE = "ProductAlternative";

	return declare(Widget, {
		'class': 'csi-form-view-block',

		LINE_ITEM: "QuoteSRLineItem",
		QUOTE_BOM: "QuoteBOM",
		QUOTE_ROUTING: "QuoteRouting",
		SUPPLIER: "Supplier",
		FACTORY: "Factory",
		SUPPLIERFACTORY: "SupplierFactory",
		TEMPLATE: "SupplierItemTemplate",
		DIMENSIONS: "SupplierItemDimensions",
		USEMATRIX: "UseMatrix",
		colorsLabel: "ProductColors",
		sizesLabel: "ProductSizes",
		colorsId: "Colors",
		sizesId: "ProductSizes",

		// String: URL of SupplierRequest if invoked from there
		urlRequest: null,

		// Node: Product
		nodeProduct: null,

		// Object[]: dimension items
		_dimensionStore: null,

		// Node[]: Colors and Sizes displayed for selection
		_colors: null,
		_sizes: null,

		//Flag to determine if ColorAllocationStatus = WIP
		isAllocationWIP: false,

		// String[]:selected products
		_productUrls: null,

		/** @property {boolean} isCreatingPA -  indicate if it's in the case of creating product alternative  */
		isCreatingPA: null,

		/** @property {boolean} isFDDEnabled -  indicate if FDD is enabled for this product
		 * - populated on NewSupplierItemMixin onCreatePopupParams, CopySupplierRequestQuotes or NewProductAlternative -> onWizardViewPreCreate for the Wizard  */
		isFDDEnabled: null,

		/** @property {C8Node} paSpec - selected ProductAlternativeSpecification node on the first page, if this form is part of the wizard */
		paSpec: null,

		/** @property {boolean}: true if creating SupplierItem under SupplierRequest - populated on NewSupplierItemMixin onCreatePopupParams */
		bSupplierRequest: false,

		/** @property {boolean}: true if creating SupplierItem under Supplier Quote Template */
		bTemplate: false,

		getQuotePerActiveColor: function() {
			return QUOTE_PER_ACTIVE_COLOR;
		},

		setProduct: function(/*Node*/product) {
			this.nodeProduct = product;
			this.cacheView.cacheNode(product);

			this.addDefaultValue(this.DIMENSIONS, NONE);

			// only pertains to cases where there is a product
			if (product) {
				this.addFixedValue(product.$Type == "Style" ? "StyleType" : "MaterialType", product.ProductType);
			}

			// update form node with new parent product
			const supplierItem = this.getFormNode();
			const productSource = this.cacheView.get(supplierItem.__Parent__);
			this.onCreateFormNode(productSource, TYPE_PRODUCT_SOURCE);

			// set dimension store and refresh colors & sizes drop-down lists
			this.getDimensionStore();

			const colorsField = this.defView.getField(this.colorsId);
			const sizesField = this.defView.getField(this.sizesId);

			if (colorsField != null && sizesField != null && colorsField.m_control && sizesField.m_control) { // make sure both fields exist
				colorsField.m_control.set("store", this.getFieldStore(colorsField));
				sizesField.m_control.set("store", this.getFieldStore(sizesField));
			}

			// refresh aggregate stores since product is now different
			this.resetAggregateStores((field) => field.getControlName() !== this.LINE_ITEM);
		},

		_resetProductData: function() {
			// summary: reset product members back to defaults
			this._resetCachedData();
			this.nodeProduct = null;
		},

		_resetCachedData: function() {
			// summary: reset cached data
			this._colors = null;
			this._sizes = null;
			this._dimensionStore = null;
			this._removeMatrix();
		},

		// get list of suppliers or supplier factories from ProductSources
		getProductSourceSupplierOrFactoryUrlList() {
			const { isFDDEnabled, cacheView: cache } = this;
			let productSourceSuppliersOrFactories = [];
			let productSourcing = cache.getNode(this.nodeProduct.ProductSourcing);
			productSourcing.ProductSources.forEach((productSourceUrl) => {
				let productSource = cache.getNode(productSourceUrl);
				// refactoring and logic will need to be changed in this upcoming story C8-59817
				productSourceSuppliersOrFactories.push(isFDDEnabled ? productSource?.SupplierFactory : productSource?.Supplier);
			});
			return productSourceSuppliersOrFactories;
		},

		setColorsForMatrix(productType, isSupplierOrFactory, productNode) {
			// if Style or Material have Color Allocation Status enabled and the Supplier/Factory value on form is in the Product's ProductSources Supplier/SupplierFactory
			//	for matrix view, get only the Active colorways on the ProductSource.ColorProductSource
			let colors;
			const { isFDDEnabled, cacheView: cache } = this;
			const product = this.bSupplierRequest ? this.nodeProduct : productNode;
			let supplierOrFactoryFieldValue = isFDDEnabled ? this.getFieldValue(this.FACTORY) : this.getFieldValue(this.SUPPLIER);
			if (!xml.isValidURL(supplierOrFactoryFieldValue)) {
				supplierOrFactoryFieldValue = this.getSourceOnProductSource(cache);
			}
			this.isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(this.nodeProduct);
			if (productType &&
				this.isAllocationWIP &&
				isSupplierOrFactory) {
				let supplierOrFactoryMatchingList = [];
				colors = array.filter(cache.getChildren(product, "ProductColors"), function (c) {
					let colorProductSourceUrlList = c.ColorwayColorSources;
					supplierOrFactoryMatchingList = colorProductSourceUrlList?.filter(cpsUrl => {
						// get ProductSource from ColorProductSource
						let cps = resolver.resolveNode(cpsUrl, cache);
						let productSource = cache.getNode(cps?.__Parent__);
						// return if ProductSource supplier/factory === supplier/factory value on form
						let supplierOrFactory = isFDDEnabled ? productSource?.SupplierFactory : productSource?.Supplier;
						return supplierOrFactoryFieldValue?.includes(supplierOrFactory) && cps.Active;
					})
					// refactoring and logic will need to be changed in this upcoming story C8-59817
					return c.Active && supplierOrFactoryMatchingList?.length;
				});
			} else {
				colors = array.filter(cache.getChildren(this.nodeProduct, "ProductColors"), function (c) { return c.Active; }); // just get active colorways
			}
			return colors;

		},

		getDimensionStore: function() {
			// needed for correct drop-down options in a ProductSource
			this._colors = null;
			this._sizes = null;
			this._dimensionStore = null;
			// summary: get the store for dimensions. Store the list of colors and sizes along the way
			const { isFDDEnabled, cacheView: cache } = this;
			if (!this._dimensionStore) {
				let productSourceSuppliersOrFactories = [];
				let productType = this.nodeProduct?.$Type === "Style" || this.nodeProduct?.$Type === "Material";
				let supplierOrFactoryFieldValue = isFDDEnabled ? this.getFieldValue(this.FACTORY) : this.getFieldValue(this.SUPPLIER);

				if (!xml.isValidURL(supplierOrFactoryFieldValue) && !this.bSupplierRequest) {
					supplierOrFactoryFieldValue = this.getSourceOnProductSource(cache);
				}

				var nColors, nSizes;

				if (this.nodeProduct) {
					if (productType) {
						productSourceSuppliersOrFactories = this.getProductSourceSupplierOrFactoryUrlList();
					}

					let colors;
					if (this.bSupplierRequest) {
						colors = this.setColorsForMatrix(productType, productSourceSuppliersOrFactories.some(item => supplierOrFactoryFieldValue.includes(item)), this.nodeProduct);
					} else {
						colors = this.setColorsForMatrix(productType, productSourceSuppliersOrFactories.includes(supplierOrFactoryFieldValue), this.nodeProduct);
					}
					const sizes = cache.getChildren(this.nodeProduct, "ProductSizes", true);

					nColors = colors ? colors.length : 0;
					nSizes = sizes ? sizes.length : 0;

					this._colors = colors;
					this._sizes = sizes;

				}

				let productExistsInList;

				if (this.bSupplierRequest) {
					productExistsInList = productSourceSuppliersOrFactories.some(item => supplierOrFactoryFieldValue.includes(item));
				} else {
					productExistsInList = productSourceSuppliersOrFactories.includes(supplierOrFactoryFieldValue);
				}
				// populate possible drop-down values for dimensions
				var items = [];

				items.push({name: locale.resource("None"), id: NONE});
				this.isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(this.nodeProduct);
				// Colors option only when ColorAllocationStatus is Off or WIP and supplier is in Style or Material product source
				// Show colors field if we are inside a Supplier Request and we select one source
				if (nColors &&
					((productType && this.isAllocationWIP && productExistsInList && !this.bSupplierRequest) ||  (this.isAllocationWIP && this.bSupplierRequest && supplierOrFactoryFieldValue.length == 1)
					|| (productType && !this.isAllocationWIP)
					|| !productType)) {
					items.push({name: locale.resource("SupplierItemDimColors"), id: COLORS});
				}

				if (nSizes) {
					items.push({name: locale.resource("SupplierItemDimSizes"), id: SIZES});
				}

				// Color and Sizes option only when ColorAllocationStatus is Off or WIP and supplier is in Style or Material product source
				// Show colors and sizes field if we are inside a Supplier Request and we select one source
				if (nColors && nSizes  &&
					((this.isAllocationWIP && productExistsInList && !this.bSupplierRequest) || (this.isAllocationWIP && productExistsInList && this.bSupplierRequest && supplierOrFactoryFieldValue.length == 1)
					|| (!this.isAllocationWIP)
					|| !productType)) {
					items.push({name: locale.resource("SupplierItemDimAll"), id: COLORS_AND_SIZES});
				}

				var fd = this.defView.m_formData;
				if (this.bSupplierRequest) {
					var productHasColors = _.some(this._productUrls, function(lineItem) {
						var lineItemNode = cache.getNode(lineItem);
						var lineItemProduct = cache.getNode(lineItemNode.SRLineItemProduct);
						return (lineItemProduct) ? !!lineItemProduct.ProductColors.length : false;
					});
					if (nColors || (!this.nodeProduct && productHasColors)) {
						items.push({name: locale.resource("QuotePerActiveColor"), id: QUOTE_PER_ACTIVE_COLOR});
					}
				}

				this._dimensionStore = new Memory({data: items});
			}

			return this._dimensionStore;
		},

		_getRootRequest: function(/*Node*/node) {
			// summary: get root request for nodes needed by view
			const { FACTORY } = this;
			var urls = [];
			var paths = [];

			if (node) {
				urls.push(node.$URL);
				paths.push("Child:QuoteSRLineItem/Child:SRLineItemProduct");
				paths.push("Child:AdoptedFromSRLineItem");
				paths.push("Child:__Parent__/Child:__Parent__");
			}
			var srNode = this.cacheView.getNode(this.urlRequest);
			if (srNode) {
				urls.push(srNode.$URL);
				paths.push("Child:LineItems/Child:SRLineItemProduct");
			}

			if (this.nodeProduct) {
				urls.push(this.nodeProduct.$URL);
				paths.push("Child:ProductColors;ProductSizes;ProductSourcing");

				// purpose: include supplier factory and factory nodes in cache when creating Supplier Item under Style or Material
				if (this.defView.m_formData.getField(FACTORY) != null) {
					paths.push("Child:ProductSourcing/Child:ProductSources/Child:SupplierFactory");
				}
			}

			if (urls.length) {
				return comm.getNodeRequest(urls, null, true).addDependencyPaths(paths);
			}

			// if node is null, then no request will be made from this.inherited
			return null;
		},

		/**
		 * @override
		 * Attach ProductSource to product sourcing node in context
		 */
		onCreateFormNode(node, type) {
			if (type === TYPE_PRODUCT_SOURCE) {
				const {nodeProduct} = this;
				if (nodeProduct && node) {
					node.__Parent__ = nodeProduct.ProductSourcing;
				}
			}
		},

		/**
		 * @override
		 * Hide template field if no values, set the default factory/supplier if only one suggested
		 */
		onSetDefaultValue(field, store, value) {
			this.inherited(arguments);

			switch (field.getControlName()) {
				case this.TEMPLATE:
					if (store.isStoreEmpty()) {
						this.setFieldHidden(field, true);
					}
					break;
				case this.SUPPLIER:
				case this.FACTORY:
					// Set the suggested value as default if there is only one suggested value
					const groups = store.aggregateStoreResponse?.groups;
					const suggested = groups?.find((group) => group.suggested);
					if (suggested && suggested.results.length === 1) {
						const name = field.getControlName();
						this.setFieldStore(name, store);
						this.setFieldValue(name, suggested.results[0].$id);
					}
					break;
			}
		},

		/**
		 * @override
		 * Attach form node to parent product
		 */
		onWriteFormReport(field, writer, formInfo) {
			const {nodeUrl, parentUrl} = formInfo;

			// if creating SupplierItem directly under ProductSource, then nothing else to do
			if (parentUrl) {
				return;
			}

			// if creating under product, then create path up to product
			const {nodeProduct} = this;

			if (nodeProduct) {
				writer.createNode(null, TYPE_PRODUCT_SOURCE)
					.attach(nodeProduct.ProductSourcing, ATTR_SOURCING_SOURCES)
					.changeAttribute(ATTR_SOURCE_SUPPLIER_ITEMS, xml.ATTR_REFSET, [nodeUrl]);
			}

			const selectedProductAlternativeSpecUrl = this.paSpec?.$URL;

			// build the context so that aggregate store would work properly
			if (selectedProductAlternativeSpecUrl) {
				const productAlternativeUrl = xml.getClientNodeUrl();

				writer.changeNode(selectedProductAlternativeSpecUrl)
				.changeAttribute(xml.ATTR_PARENT,xml.ATTR_REF, productAlternativeUrl);

				writer
				.createNode(productAlternativeUrl, PRODUCT_ALTERNATIVE)
				.changeAttribute("PASpec",xml.ATTR_REF, this.paSpec.$URL)
				.changeAttribute(xml.ATTR_PARENT,xml.ATTR_REF, nodeProduct.$URL)
				.attach(xml.getUrlPath(nodeUrl, "Child:LatestRevision"), "QuoteProductAlternative");
			}
		},

		/**
		 * @override
		 * Only fill in active colorways during copy action
		 */
		getValueForField: function(field, node) {
			const {cacheView, colorsId, isAllocationWIP} = this;

			if (this.isCopy() && field.m_id === colorsId) {
				const quoteRevisionColors = cacheView.getPathNodes(this.getViewNode(), "Child:CurrentRevision/Child:Colors");
				// if we have no colors, return early
				if (!quoteRevisionColors) {
					return this.inherited(arguments);
				}
				const activeQuoteRevisionColors=quoteRevisionColors.filter(c => c.Active).map(c => c.$URL);

				// Only fill in active color product sources if color allocation is enabled
				if (isAllocationWIP) {
					return cacheView.getPathNodes(this.getViewNode(), "Child:__Parent__/Child:ColorSources")
						.filter(cps => cps.Active && activeQuoteRevisionColors.includes(cps.Colorway))
						.map(cps => cps.Colorway);
				}

				return activeQuoteRevisionColors;
			}
			return this.inherited(arguments);
		},

		_redraw: function() {
			this._resetCachedData();
			this.inherited(arguments);
		},

		_buildForm: function() {
			this.inherited(arguments);
			this._updateFieldVisibility(this.defView.getField(this.DIMENSIONS));
			this._updateStatistics();
		},

		_rebuildDimensionField: function() {
			var dimField = this.defView.getField(this.DIMENSIONS);

			// dimStore should be ready now - just tie it to the dimField
			if (dimField && dimField.m_control) {
				dimField.m_control.set("store", this.getFieldStore(dimField));
			}
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			let { isFDDEnabled } = this;
			let supplierOrFactoryFieldValue = isFDDEnabled ? this.getFieldValue(this.FACTORY) : this.getFieldValue(this.SUPPLIER);
			// summary: if field is for LineItem or Supplier, then add SelectAll option
			var name = field.getControlName();
			if (name == this.DIMENSIONS) {
				return this.getDimensionStore();
			}

			if (this.isCopy() && name == this.LINE_ITEM) {
				var quote = this.getViewNode();
				var quoteLineItem = this.cacheView.getNode(quote.QuoteSRLineItem);
				var origLineItem = this.cacheView.getNode(quote.AdoptedFromSRLineItem);

				var data = [];
				if (quoteLineItem) {
					data.push({"id": quoteLineItem.$URL, "name": quoteLineItem.$Name});
				}
				if (origLineItem) {
					data.push({"id": origLineItem.$URL, "name": origLineItem.$Name});
				}
				return new Memory({data: data});
			} else if (name == this.LINE_ITEM && this.urlRequest) {
				var gotoDialog = "QuoteSRLineItem";
				var rel = field.m_relationship;
				var params = {
					m_id: rel.m_id,
					m_url: rel.m_url,
					m_query: rel.m_query
				};
				return this._getStore(gotoDialog, params, rel);
			} else if (this.nodeProduct && (name == "Colors" || name == "ProductSizes")) { // make sure we have a legitimate product

				var id, gotoDialog;

				// if dimension store is already built, it needs to be regenerated so clear here
				this._dimensionStore = null;

				if (name == "Colors") {
					id = "ProductColors";
					gotoDialog = "ProductColor";
				} else if (name == "ProductSizes") {
					id = "ProductSizes";
					gotoDialog = "ProductSize";
				}

				var params = {
					m_id: id,
					m_url: this.nodeProduct.$URL
				};

				var storeOptions;
				this.isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(this.nodeProduct);
				if (id === "ProductColors") {
					const { nodeProduct, cacheView, isAllocationWIP }= this;
					let activeColorsInActiveColorProductSources;
					let q = new Query();
					if (nodeProduct?.ColorAllocationStatus && isAllocationWIP && this.getProductSourceSupplierOrFactoryUrlList().some(item => supplierOrFactoryFieldValue?.includes(item))) {		
						// If in SR, supplierOrFactoryFieldValue will be array so get the first index since Colors will be shown if there is only one Supplier/Factory
						if (Array.isArray(supplierOrFactoryFieldValue) && supplierOrFactoryFieldValue.length > 0) {
							supplierOrFactoryFieldValue = supplierOrFactoryFieldValue[0];
						}
						// This filter is needed when supplier or factory is single-select(Color Allocation Status === WIP) to only get colorways that are in the ProductSource
						//	of the Supplier selected on the form
						q.Attr("Active", xml.OP_EQUALS, true)
							.RefAttr(isFDDEnabled ? "SupplierFactory" : "Supplier", xml.OP_EQUALS, supplierOrFactoryFieldValue, "Child:ColorwayColorSources/Child:__Parent__")
							.Attr("Active", xml.OP_EQUALS, true, "Child:ColorwayColorSources");
						activeColorsInActiveColorProductSources = Sourcing.getActiveColorsInActiveColorProductSources(nodeProduct, supplierOrFactoryFieldValue, cacheView);
						let qOr = q.Or();
						activeColorsInActiveColorProductSources.forEach((c) => {
							qOr.Node(xml.PROP_URL, xml.OP_EQUALS, c);
						});
					} else if (nodeProduct?.ColorAllocationStatus && isAllocationWIP && !supplierOrFactoryFieldValue) {
						const productSource = this.urlRequest == null ? cacheView.getNode(this.formInfo?.parentUrl) : cacheView.getNode(this.urlRequest);
						const isFDDEnabled = Sourcing.isFDDEnabled(nodeProduct, cacheView);
						const sourceURL = isFDDEnabled ? productSource?.SupplierFactory : productSource?.Supplier;
						const source = isFDDEnabled ? "SupplierFactory" : "Supplier";
						q.Attr("Active", xml.OP_EQUALS, true)
								.RefAttr(source, xml.OP_EQUALS, sourceURL, "Child:ColorwayColorSources/Child:__Parent__")
								.Attr("Active", xml.OP_EQUALS, true, "Child:ColorwayColorSources");
						const colorSourceNodes = cacheView.getNodes(productSource?.ColorSources);
						if (colorSourceNodes){
							activeColorsInActiveColorProductSources = colorSourceNodes.filter((cs) => cs.Active).map((cs) => cs.Colorway);
							let qOr = q.Or();
							activeColorsInActiveColorProductSources.forEach((c) => {
								qOr.Node(xml.PROP_URL, xml.OP_EQUALS, c);
							});
						}
					} else {
						q.Attr("Active", xml.OP_EQUALS, true); // only Colors needs this extra filter
					}
					params.m_query = q;
				}
				var rel = lang.mixin(new Relationship(), params);

				return this._getStore(gotoDialog, params, rel);
			}
			return this.inherited(arguments);
		},

		/**
		 * Handle retrieving of store and its action
		 * @param {String} gotoDialog - id of gotoDialog
		 * @param {String} params - different field params
		 * @param {Object} rel - field relationship
		 */
		_getStore: function(gotoDialog, params, rel) {
			var storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
			storeOptions.action = lang.mixin(new Action(), {
				m_name: locale.resource("AggregateInline_Name", [locale.typePlural(gotoDialog)]),
				m_viewRef: lang.mixin(new ViewRef(), params),
				m_fixedQuery: params.m_query // possible extra filter
			});

			return new Names(storeOptions);
		},

		_resolveView: function() {
			// summary: add supplier and template fields when necessary
			const fd = this.defView.m_formData;
			const actionNodeType = fd.getSource().getActionNodeType();

			if (PRODUCT_ALTERNATIVE === actionNodeType) {
				this.isCreatingPA = true;
			}

			const { bTemplate, isCreatingPA, isFDDEnabled, FACTORY, SUPPLIER } = this;

			if (!fd) {
				this.inherited(arguments);
				return;
			}

			const sourceNode = this.getViewNode();
			const parentNode = fd.getSource().getParent();
			const cache = this.getCache();
			const validRequestType =  ["DataPackageContainerType:Style","DataPackageContainerType:Material"].includes(parentNode.RequestType);

			// find the correct style nodes from different views
			let f;
			bProductSource = parentNode?.$Type == "ProductSource";

			// Add "Include Quotes / Samples" widget if not on a Template and on the New form
			if (!bTemplate && this.isNew()) {
				this.rightWidgetClass = SupplierQuoteRightWidget;
			}

			var selectType = def.FIELD_FILTERING_SELECT;

			if (!sourceNode) {  // sourceNode means copy
				selectType = def.FIELD_MULTI_SELECT;
			}

			// insert template field if creating from scratch - not wanted when copying from existing quote
			if (!sourceNode && !bTemplate) {
				this.insertField(lang.mixin(new Field(), {
					idParameter: "TemplateURL",
					m_bInitialize: true,
					m_label: this.TEMPLATE,
					m_onChange: "_onChangeTemplate",
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_relationship: lang.mixin(new Relationship(), {
						m_url: "centric://REFLECTION/INSTANCE/SiteLibSupplierItem/SiteLibSupplierItem",
						m_id: "Templates"
					})
				}), 0);
			}

			// init line item field if form invoked from SupplierRequest or a Copy
			if (this.bSupplierRequest || this.isCopy()) {
				this.urlRequest = parentNode.$URL;

				// see if we are on an Inspiration Style
				if (sourceNode && sourceNode.AdoptionStatus == "AdoptionStatus:Adopted") {
					this.insertField(lang.mixin(new Field(), {
						bForceEditable: true,
						m_bRequired: true,
						m_id: this.LINE_ITEM,
						m_onChange: "_onChangeLineItem",
						m_typeControl: def.FIELD_FILTERING_SELECT
					}), 0);

				} else if (!bTemplate) {
					if (this.isCopy() && state.get("userType") != "Supplier") {
						// only put this field on the form if you can see the Product
						var product = this.cacheView.getPathNode(sourceNode, "Child:__Parent__/Child:__Parent__/Child:__Parent__");
						if (product != null) {
							const productType = (product.$Type == "Material" || parentNode.RequestType == "DataPackageContainerType:Material" || parentNode.$Type == "MaterialSourcing") ? "MaterialType" : "StyleType";
							this.insertField(lang.mixin(new Field(), {
								m_id: productType,
								m_typeControl: def.FIELD_FILTERING_SELECT,
								m_relationship: lang.mixin(new Relationship(), {
									m_typeNode: productType
								})
							}), 0);
						}
					}
					this.insertField(lang.mixin(new Field(), {
						bForceEditable: !sourceNode,
						m_bRequired: true,
						m_id: this.LINE_ITEM,
						m_onChange: "_onChangeLineItem",
						m_typeControl: selectType,
						widgetParams: {defaultAll: true},
						m_relationship: lang.mixin(new Relationship(), {
							m_url: this.urlRequest,
							m_id: "LineItems",
							m_query: validRequestType ? new Query().RefAttr("SRLineItemProduct", xml.OP_NOT_EQUALS, csi.EMPTY_URL) : new Query().Attr("Hidden", xml.OP_EQUALS, false, "Child:SRLineItemProduct")
						}),
						m_right: sourceNode ? xml.RIGHT_NONE : null
					}), 1);

					const {cacheView} = this;
					const getProduct = (url) => cacheView.get(cacheView.get(url)?.SRLineItemProduct);
					const lineItem = parentNode.LineItems?.find(getProduct);
					if (lineItem && parentNode.LineItems.length === 1) {
						this.nodeProduct = getProduct(lineItem);
						this.addDefaultValue(this.LINE_ITEM, lineItem);
					}
				}

				this._productUrls = parentNode.LineItems;
			}


			const m_label = isFDDEnabled ? FACTORY : SUPPLIER;
			const m_id = isCreatingPA ? "PASpecSuppliers" : PRODUCT_SOURCES;
			const m_path = isCreatingPA ? xml.path("LatestRevision","QuoteProductAlternative","PASpec") : xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT);

			// insert supplier field if creating from outside of ProductSource
			if (!bProductSource && !bTemplate) {
				f = this.insertField(lang.mixin(new Field(), {
					bForceEditable: !sourceNode,
					m_bRequired: true,
					idParameter: "SrcURL",
					m_label,
					m_id,
					m_path,
					m_onChange: "_onChangeSupplierOrFactory",

					// prevent the form from sending a request of changing productSources to the function queryAggregateStore
					// Setting omitFromReport to false will return null from queryAggregateStore, which breaks the form
					omitFromReport: true,
				}), 0);

				// if Colorway Allocation is enabled for Style or Material and its not created under a Supplier Request, Supplier/Factory is single select
				if (!this.bSupplierRequest) {
					const isColorwayAllocationEnabled = cache.getNode(this.nodeProduct == null ? parentNode.__Parent__: this.nodeProduct.$URL)?.ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP";
					if(isColorwayAllocationEnabled) {
					f.m_typeControl = def.FIELD_FILTERING_SELECT;
					f.m_type = xml.ATTR_REF;
					}
				}

				// set supplier / supplier factory dropdown to None by default (except for designated supplier)
				const dps = cache.getNode(parentNode.DesignatedProductSource);
				this.defView.m_formData.setFieldInitialValue(SUPPLIER, dps ? [dps.Supplier] : []);
				this.defView.m_formData.setFieldInitialValue(FACTORY, dps ? [dps.SupplierFactory] : []);

				if(this.isCopy() || this.isEdit()){
					const fieldName = isFDDEnabled ? FACTORY : SUPPLIER;
					const productSource = cache.getNode(sourceNode.__Parent__);
					const fixedValUrl = isFDDEnabled ? productSource.SupplierFactory : productSource.Supplier;
					this.addFixedValue(fieldName, fixedValUrl);
					if(this.isCopy()) {
						this.defView.m_formData.setFieldInitialValue(xml.ATTR_NAME, "");
				}
			}

				if (this.urlRequest) {
					// change query if on SupplierRequest and allow for All - add SupplierFactory if FDD is enabled.
					// Not using the new aggregateStore for this special case
					if(isFDDEnabled) {
						f.m_relationship = lang.mixin(new Relationship(), {
							m_url: this.urlRequest,
							m_id: "SRSupplierFactories",
						});
					} else {
						f.m_relationship = lang.mixin(new Relationship(), {
							m_url: this.urlRequest,
							m_id: "SRSources/Child:Supplier",
							m_query: new Query().Attr("AutoCreateProductSourceOnSR", xml.OP_EQUALS, true).SortByNode(xml.PROP_NAME) // only Suppliers with AutoCreateProductSourceOnSR is set to true
						});
					}
				}
			}

			if (!bTemplate && !sourceNode && this.defView.getField("Colors") && this.defView.getField("ProductSizes")) {
				this.insertField(lang.mixin(new Field(), {
					m_label: this.DIMENSIONS,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_onChange: "_onChangeDimensions"
				}), "Colors"); // put before Colors field

				// set Colors / Sizes to NONE by default
				this.addDefaultValue(this.DIMENSIONS, NONE);

				this.insertField(lang.mixin(new Field(), {
					m_label: this.USEMATRIX,
					m_typeControl: def.FIELD_CHECKBOX,
					m_onChange: "_onChangeUseMatrix",
					bCombineWithPrevious: true
				}), "Colors");
			}

			this.inherited(arguments);
		},

		onChangeField(field) {
			this.inherited(arguments);
			this._updateStatistics();
		},

		_onChangeSupplierOrFactory(defView, field, value) {
			if (value.length) {
				this.setFieldHidden(this.DIMENSIONS, false);
			} else {
				this.setFieldHidden(this.DIMENSIONS, true);
			}
			if (this.isAllocationWIP) {
				this.resetFieldStoreAndValue(this.DIMENSIONS, 0);
				this.resetFieldStoreAndValue(this.colorsId);
			}
		},

		_onChangeUseMatrix: function(defView, field, value) {
			this._refreshDimensionRelatedFields(value);
		},

		_onChangeDimensions: function(defView, field, value) {
			this._refreshDimensionRelatedFields(undefined, value);
			this.publishDomChange();
		},

		_refreshDimensionRelatedFields: function(useMatrixValue, dimensionsFieldValue) {
			// summary: render size / color fields based on selection
			//  0 - remove size/color
			//  1 - color
			//  2 - size
			//  3 - size & color
			//	4 - Quote per active color
			// also when custom input is enabled removed size/color/quantity fields
			if (!useMatrixValue)
				useMatrixValue = this.getFieldValue(this.USEMATRIX);
			if (!dimensionsFieldValue)
				dimensionsFieldValue = this.defView.getFieldValue(this.DIMENSIONS);
			this.setFieldHidden(this.colorsLabel, useMatrixValue || (dimensionsFieldValue != this.DIM_COLORS && dimensionsFieldValue != this.DIM_COLORS_AND_SIZES));
			this.setFieldHidden(this.sizesLabel, useMatrixValue || (dimensionsFieldValue != this.DIM_SIZES && dimensionsFieldValue != this.DIM_COLORS_AND_SIZES));

			this._removeMatrix();

			if (dimensionsFieldValue != NONE && dimensionsFieldValue != QUOTE_PER_ACTIVE_COLOR && useMatrixValue) {
				this._addMatrix();
			}
		},

		_updateStatistics: function() {
			const {cacheView, defView, rightWidget, _matrix, FACTORY, SUPPLIER } = this;

			if (!rightWidget)
				return; // nothing to do

			let colorSizePairsLength = 0;
			let colorsLength = 0;
			let sizesLength = 0;
			let products = [];
			let sourcesLength = 0;
			let numQuotes = 0;

			// if Supplier/Factory is single select then either 0 if none selected or 1 if selected
			if (this.getField(SUPPLIER)) {
				sourcesLength = this.getField(SUPPLIER).m_typeControl === def.FIELD_MULTI_SELECT ? this.getFieldValue(SUPPLIER).length : (this.getFieldValue(SUPPLIER) === "" ? 0 : 1);
			} else if (this.getField(FACTORY)){
				sourcesLength = this.getField(FACTORY).m_typeControl === def.FIELD_MULTI_SELECT ? this.getFieldValue(FACTORY).length : (this.getFieldValue(FACTORY) === "" ? 0 : 1);
			}

			const parentNode = defView.getSource().getParent();
			if (parentNode.$Type == "StyleSourcing" || parentNode.$Type == "MaterialSourcing") {
				products = [parentNode.__Parent__];
			} else if (parentNode.$Type == "ProductSource") {
				products = [cacheView.getNode(parentNode.__Parent__).__Parent__];
				sourcesLength = 1;
			} else {
				const lineItems = this.getFieldValue(this.LINE_ITEM);
				if (Array.isArray(lineItems)) {
					for (const li of lineItems) {
						products.push(cacheView.getNode(li).SRLineItemProduct);
					}
				}
			}

			const value = this.getFieldValue(this.DIMENSIONS) || NONE;
			if (value == NONE) {
				colorSizePairsLength = products.length;
			} else if (value == QUOTE_PER_ACTIVE_COLOR) {
				// loop through all the line items, get the Products and count the active colors
				for (const product of products) {
					const productNode = cacheView.getNode(product);
					const isFDDEnabled = Sourcing.isFDDEnabled(productNode, cacheView);
					let supplierOrFactoryValue = isFDDEnabled ? this.getFieldValue(FACTORY) : this.getFieldValue(SUPPLIER);
					let array = this.getNumQuotesForQuotesPerActiveColor(productNode, cacheView, colorSizePairsLength, numQuotes, sourcesLength, supplierOrFactoryValue);
					colorSizePairsLength = array[0];
					numQuotes = array[1];
				}
				if (products.length > 1) {
					colorsLength = "--";
				} else {
					colorsLength = colorSizePairsLength;
				}
			} else if (value == SIZES) {
				sizesLength = _matrix ? this.getSelectedColorSizePairs().length : this.getFieldValue(this.sizesId).length;
				colorSizePairsLength = sizesLength;
			} else if (value == COLORS) {
				colorsLength = _matrix ? this.getSelectedColorSizePairs().length : this.getFieldValue(this.colorsId).length;
				colorSizePairsLength = colorsLength;
			} else {
				// colors & sizes
				if (_matrix) {
					const colorSizePairs = this.getSelectedColorSizePairs();

					// count number of distinct colors / sizes selected in the matrix
					let matrixColors = {}, matrixSizes = {};
					for (const p of colorSizePairs) {
						matrixColors[p.c.$URL] = true;
						matrixSizes[p.s.$URL] = true;
					}
					sizesLength = Object.keys(matrixSizes).length;
					colorsLength = Object.keys(matrixColors).length;
					colorSizePairsLength = colorSizePairs.length;
				} else {
					sizesLength = this.getFieldValue(this.sizesId).length;
					colorsLength = this.getFieldValue(this.colorsId).length;
					colorSizePairsLength = sizesLength * colorsLength;
				}
			}

			rightWidget.set("numSuppliers", sourcesLength);
			rightWidget.set("numFactories", sourcesLength);
			rightWidget.set("numColorways", colorsLength);
			rightWidget.set("numColoredMaterials", colorsLength);
			rightWidget.set("numSizes", sizesLength);

			if (value == QUOTE_PER_ACTIVE_COLOR) {
				// when quotes per active color is selected, numQuotes needs to be used to account for multiple products which might contain
				// products which are both Allocated WIP or not Allocated WIP
				rightWidget.set("numQuotes", numQuotes);
			} else {
				rightWidget.set("numQuotes", colorSizePairsLength * sourcesLength);
			}
		},

		_addMatrix: function() {
			// no matrix needed for first two values
			var value = this.defView.getFieldValue(this.DIMENSIONS);
			if (value == NONE || value == QUOTE_PER_ACTIVE_COLOR) {
				return;
			}

			var bColumns = (value == COLORS_AND_SIZES);
			var bColors = bColumns || (value == COLORS);
			var cache = this.cacheView;

			this._matrixRow = this._createFieldDom();

			// form using csi-form-view-block is using display:block, so no need to create th or td
			var domNode = html.create('div', {style: 'padding-top: 6px;'}, this._matrixRow);

			function _createStore(nodes, bActive) {
				if (bActive) {
					nodes = _.filter(nodes, function(node) {
						return node.Active;
					});
				}

				return new Memory({
					labelProperty: "name",
					data: _.map(nodes, function(node) {
						return {id: node.$URL, name: locale.getNodeName(node, cache)};
					})
				});
			}

			// matrix should always default to 0
			this._matrix = new MatrixEditorWithCheckBox({
				label: locale.resource("SizeMapSelectAll"),
				columnLabel: bColumns ? locale.resource(this.sizesLabel) : '',
				columnStore: bColumns ? _createStore(this._sizes) : null,
				rowLabel: locale.resource(bColors ? this.colorsLabel : this.sizesLabel),
				rowStore: _createStore(bColors ? this._colors : this._sizes, bColors),
				onChange: (value) => this._updateStatistics()
			}).placeAt(domNode);
		},

		_removeMatrix: function() {
			html.destroyElement(this._matrixRow);
			this._matrixRow = null;
			this._matrix = null;
		},

		_updateFieldVisibility: function(/*Field?*/field) {
			// summary: set visibility of fields
			var b = this.inherited(arguments);

			// if you are a Supplier user, make the LINE_ITEM field read-only on Copy.  you can tell since styleSourcing would be null
			if (this.isCopy()) {
				var styleSourcing = this.cacheView.getNode(this.cacheView.getNode(this.getViewNode().__Parent__).__Parent__);
				if (!styleSourcing) {
					this.setFieldDisabled(this.LINE_ITEM, true);
				}
			}

			var productColorField = this.defView.getField("Colors");
			var productSizeField = this.defView.getField("ProductSizes");
			var useMatrixField = this.getField(this.USEMATRIX);

			if (!field) {
				this.setFieldHidden(this.QUOTE_ROUTING, !ProductType.hasTDS(null, "Routing"));
				this.setFieldHidden(this.QUOTE_BOM, !(ProductType.hasTDS(null, "ApparelBOM") || ProductType.hasTDS(null, "MaterialBOM")));

				// see if we are dealing with supplier quote templates (the parent would be this special node)
				var fd = this.defView.m_formData;
				var parentNode = fd.getSource().getParent();
				if (this.bTemplate) {
					this.setFieldHidden(productColorField, true);
					this.setFieldHidden(productSizeField, true);
				} else {
					if (parentNode && (parentNode.$Type == "StyleSourcing" || parentNode.$Type == "MaterialSourcing")) {
						var productNode = this.cacheView.getNode(parentNode.__Parent__);

						if (!ProductType.hasColor(productNode))
							this.setFieldHidden(productColorField, true);
						if (!ProductType.hasSize(productNode))
							this.setFieldHidden(productSizeField, true);
					}
				}

				// if you are on a Copy and the line item is blank, hide it
				if (this.isCopy() && fd.getSource().getNode().QuoteSRLineItem == csi.EMPTY_URL) {
					this.setFieldHidden(this.LINE_ITEM, true);
				}

				return true;
			}

			// if dimensions is there, use that instead
			var value = this.defView.getFieldValue(this.DIMENSIONS);
			if (useMatrixField) {
				this.setFieldHidden(useMatrixField, value == NONE || value == QUOTE_PER_ACTIVE_COLOR);
				this.setFieldHidden(productColorField, useMatrixField.getValue() || (value != COLORS && value != COLORS_AND_SIZES));
				this.setFieldHidden(productSizeField, useMatrixField.getValue() || (value != SIZES && value != COLORS_AND_SIZES));
			}

			return b;
		},

		getSelectedColorSizePairs: function() {
			// summary: returns the array of pairs color/size selected.
			// Each pair is an object of format: {c:<color-node>, s:<size-node>}.
			// Returns null if the user choose do not create color/size specific SupplierItem-s
			var pairs = [];
			var dims = this.defView.getFieldValue(this.DIMENSIONS);
			var colors = this.defView.getFieldValue("Colors");
			var sizes = this.defView.getFieldValue("ProductSizes");

			var colorMap = csi.hashArray(this._colors, "$URL");
			var sizeMap = csi.hashArray(this._sizes, "$URL");

			var matrix = this._matrix;
			var matrixValues;

			if (matrix) {
				// try to update data from editor fields.
				matrixValues = matrix.get("value");
			}

			if (dims == COLORS) {
				if (matrix) {
					matrix.rowStore.query().forEach(function(item, i) {
						var id = item.id;
						var values = matrixValues[i];
						if (values[0])
							pairs.push({c: colorMap[id]});
					}, this);
				} else {
					colors.forEach(function(color) {
						pairs.push({c: colorMap[color]});
					});
				}
			} else if (dims == SIZES) {
				if (matrix) {
					matrix.rowStore.query().forEach(function(item, i) {
						var id = item.id;
						var values = matrixValues[i];
						if (values[0])
							pairs.push({s: sizeMap[id]});
					}, this);
				} else {
					sizes.forEach(function(size) {
						pairs.push({s: sizeMap[size]});
					});
				}
			} else if (dims == COLORS_AND_SIZES) {
				if (matrix) {
					matrix.rowStore.query().forEach(function(item, i) {
						var id = item.id;
						var values = matrixValues[i];
						var sizeResults = (dims == COLORS_AND_SIZES) ? matrix.columnStore.query() : null;
						sizeResults.forEach(function(size, i) {
							if (values[i])
								pairs.push({c: colorMap[id], s: sizeMap[size.id]});
						});
					}, this);
				} else {
					colors.forEach(function(color) {
						sizes.forEach(function(size) { // cartesian product
							pairs.push({c: colorMap[color], s: sizeMap[size]});
						});
					});
				}
			}

			return pairs;
		},

		_onChangeTemplate: function(/*def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: initialize name based on selection if color name not already set
			var f = this.defView.getField(xml.ATTR_NAME);
			if (f && f.isDefaultValue()) {
				var nodeName = (value != csi.EMPTY_URL) ? this.cacheView.getNode(value, true).$Name : "";
				this.setFieldValue(f, nodeName, true);
			}
		},

		//TODO: Implement the following function to satisfy the task:
		// TA22934 Update Supplier Quote create on Supplier Request to support create of color/size quotes.
		// S8709: [Mango] Mass create quotes per color/size.
		_onChangeLineItem: function(/*def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update dimensions based on selected product if line item field is visible
			if (!this.isFieldVisible(field)) {
				return;
			}

			this._resetProductData();

			// set selected products
			if (Array.isArray(value) && value.length > 1) {
				this._productUrls = value;
			}

			// setup new product
			var lineItem = this.cacheView.getNode(value);
			var urlProduct = lineItem?.SRLineItemProduct;
			this.setProduct(this.cacheView.getNode(urlProduct));

			// re-build fields if product selected
			this._preProcessProduct();
			this._rebuildDimensionField();

			// hide Colors / Sizes
			var dimField = this.defView.getField(this.DIMENSIONS);
			if (dimField && dimField.m_control) {
				dimField.m_control.set("value", 0); // 0 is <None>
			}

			this.publishDomChange();
		},

		_preProcessProduct: function() {
			// summary: return array of possible dimension values for given product
			var dimField = this.defView.getField(this.DIMENSIONS);
			if (dimField)
				dimField.bHidden = false;
		},

		/**
		 * @override
		 * hide "factories/suppliers selected" on the side statistics panel (Supplier Quote Overview) depending if FDD is enabled or not.
		 */
		_buildView: function() {
			this.inherited(arguments);
			const {bTemplate, isFDDEnabled, rightWidget} = this;
			if (!this.isCopy() && !bTemplate && !this.isEdit()) {
				if (isFDDEnabled) {
					html.hide(rightWidget.suppliersNode.parentNode);
				} else {
					html.hide(rightWidget.factoriesNode.parentNode);
				}
				if (this.nodeProduct?.$Type === "Material") {
					html.hide(rightWidget.colorwaysNode.parentNode);
				} else {
					html.hide(rightWidget.coloredMaterialsNode.parentNode);
				}
			}
		},

		/**
		 * get numQuotes count for panel statistics if per active color
		 * @return {array[]} - return array of values containing count to be used to calculated Quotes to be generated
		 */
		getNumQuotesForQuotesPerActiveColor(productNode, cacheView, colorSizePairsLength, numQuotes, sourcesLength, supplierOrFactoryValue) {
			this.isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(productNode);
			if (this.isAllocationWIP) {
				if (this.bSupplierRequest) {
					for (let i = 0; i < this.getFieldValue(this.LINE_ITEM).length; i++) {
						const lineItem = this.getFieldValue(this.LINE_ITEM)[i];
						// if Product has Allocation WIP, only want to count colors that are in active colorProductSources
						let allocatedCPSColorsLength = Sourcing.getCountColorsInActiveCPS(productNode, supplierOrFactoryValue, cacheView, lineItem);
						colorSizePairsLength += allocatedCPSColorsLength;
						// numQuotes just count for colors in allocated CPS
						numQuotes += allocatedCPSColorsLength;
					}
				} else {
					let allocatedCPSColorsLength = Sourcing.getCountColorsInActiveCPSNoLineItem(productNode, this.urlSource === null ? supplierOrFactoryValue : this.urlSource, cacheView);
					colorSizePairsLength += allocatedCPSColorsLength;
					// numQuotes just count for colors in allocated CPS
					numQuotes += allocatedCPSColorsLength;
				}

			} else {
				let pcLength = (productNode.$Type == "Style" ?
								productNode.ActiveColorways.length :
								cacheView.getNodes(productNode.ProductColors).filter(n => n.Active).length);  // have to filter manually
				colorSizePairsLength += pcLength;
				// if product is not Allocation WIP, we just count numQuotes as num of Active colors * sourcesLength
				numQuotes += pcLength * sourcesLength;
			}

			let array = [];
			array.push(colorSizePairsLength)
			array.push(numQuotes)

			return array;
		},

		/**
		 * get Supplier/SupplierFactory on Product Source
		 * @return {URL} - return Supplier/SupplierFactory
		 */
		getSourceOnProductSource(cache) {
			const productSource = this.urlRequest == null ? cache.getNode(this.formInfo?.parentUrl) : cache.getNode(this.urlRequest);
			return supplierOrFactoryFieldValue = !xml.isValidURL(productSource?.SupplierFactory) ? productSource?.Supplier : productSource?.SupplierFactory;
		},
	});
});
